import { render, staticRenderFns } from "./GrupoConductores.vue?vue&type=template&id=0bb734f4&"
import script from "./GrupoConductores.vue?vue&type=script&lang=ts&"
export * from "./GrupoConductores.vue?vue&type=script&lang=ts&"
import style0 from "./GrupoConductores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports